import { Storefront } from '@mui/icons-material'
import { Grid2 as Grid, Stack, Typography } from '@mui/material'

type StoreAddressProps = {
  name: string
  address1: string
  city: string
  state: string
  postalCode: string
}

export const StoreAddress: React.FC<StoreAddressProps> = props => {
  const { address1, city, state, name } = props

  return (
    <Grid
      container
      direction={'row'}
      justifyContent={'space-between'}
      alignItems={'center'}
      spacing={2}
    >
      <Stack direction={'row'} spacing={2} alignItems="center">
        <Storefront />
        <Grid container direction={'row'} spacing={1}>
          <Typography>{name} - </Typography>
          <Typography>{address1} - </Typography>
          <Typography>
            {city} - {state}
          </Typography>
        </Grid>
      </Stack>
    </Grid>
  )
}
